import { render, staticRenderFns } from "./SelectWithSearchTableOld.vue?vue&type=template&id=4464f2f7&scoped=true"
import script from "./SelectWithSearchTableOld.vue?vue&type=script&lang=js"
export * from "./SelectWithSearchTableOld.vue?vue&type=script&lang=js"
import style0 from "./SelectWithSearchTableOld.vue?vue&type=style&index=0&id=4464f2f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464f2f7",
  null
  
)

export default component.exports